<template>
    <div class="apply_sence_container" id="apply_sence">
        <div class="apply_sence_gradient_1">
            <div class="apply_sence_gradient_2" v-lazy:background-image="require('@/assets/static/imgs/home/bg-player.png')">
                <div class="apply_sence_main">
                    <div class="apply_sence_title">{{ $t('index.apply_sence_title') }}</div>
                    <div class="apply_sence_desc">{{ $t('index.apply_sence_desc') }}</div>

                    <div class="apply_sence_menu">
                        <div 
                            class="apply_sence_menu_item" 
                            v-for="(item, index) in showImgMenuArr" :key="'show-img-menu-' + index" 
                            :class="{active: currentOpenMenuIndex === index}" 
                            @mouseenter="showBottomContent(index)">
                            <img v-lazy="item" @error="handleError" alt="ICON" />
                            {{ $t('index.apply_sence_menu_item_title_'+index) }}
                        </div>
                    </div>

                    <div class="apply_sence_content animate__animated animate__fadeInLeft" v-if="currentOpenMenuIndex === 0">
                        <div class="apply_sence_content_left">
                            <p>{{ $t('index.apply_sence_content_left_title_0') }}</p>
                            <p>{{ $t('index.apply_sence_content_left_desc_0') }}</p>
                        </div>

                        <div class="apply_sence_content_right">
                            <div class="sence_add_box">
                                <video 
                                    v-if="video0Loaded" 
                                    v-for="(item, index) in senceVideos.game_center" :key="'game_center_' + index" 
                                    :poster="applySenceComponentsPoster" 
                                    :autoplay="true" 
                                    :loop="true" 
                                    class="spi01" 
                                    data-object-fit="true" 
                                    controls 
                                    muted>
                                    <source :src="item" type="video/mp4">
                                    Sorry, your browser does not support embedded videos.
                                </video>
                            </div>
                        </div>
                    </div>

                    <div class="apply_sence_content animate__animated animate__fadeInRight" v-if="currentOpenMenuIndex === 1">
                        <div class="apply_sence_content_left">
                            <p>{{ $t('index.apply_sence_content_left_title_1') }}</p>
                            <p>{{ $t('index.apply_sence_content_left_desc_1') }}</p>
                        </div>

                        <div class="apply_sence_content_right">
                            <div class="sence_add_box">
                                <video 
                                    v-if="video1Loaded" 
                                    v-for="(item, index) in senceVideos.live_streaming" :key="'live_streaming_' + index" 
                                    :poster="applySenceComponentsPoster" 
                                    :autoplay="true" 
                                    :loop="true" 
                                    class="spi01" 
                                    data-object-fit="true" 
                                    controls 
                                    muted>
                                    <source :src="item" type="video/mp4">
                                    Sorry, your browser does not support embedded videos.
                                </video>
                            </div>
                        </div>
                    </div>

                    <div class="apply_sence_content animate__animated animate__fadeInLeft" v-if="currentOpenMenuIndex === 2">
                        <div class="apply_sence_content_left">
                            <p>{{ $t('index.apply_sence_content_left_title_2') }}</p>
                            <p>{{ $t('index.apply_sence_content_left_desc_2') }}</p>
                        </div>

                        <div class="apply_sence_content_right">
                            <div class="sence_add_box">
                                <video 
                                    v-if="video2Loaded" 
                                    v-for="(item, index) in senceVideos.chat_room" :key="'chat_room_' + index" 
                                    :poster="applySenceComponentsPoster" 
                                    :autoplay="true" 
                                    :loop="true" 
                                    class="spi01" 
                                    data-object-fit="true" 
                                    controls 
                                    muted>
                                    <source :src="item" type="video/mp4">
                                    Sorry, your browser does not support embedded videos.
                                </video>
                            </div>
                        </div>
                    </div>

                    <div class="apply_sence_content animate__animated animate__fadeInRight" v-if="currentOpenMenuIndex === 3">
                        <div class="apply_sence_content_left">
                            <p>{{ $t('index.apply_sence_content_left_title_3') }}</p>
                            <p>{{ $t('index.apply_sence_content_left_desc_3') }}</p>
                        </div>

                        <div class="apply_sence_content_right">
                            <div class="sence_add_box">
                                <video 
                                    v-if="video3Loaded" 
                                    v-for="(item, index) in senceVideos.battle_social" :key="'battle_social_' + index" 
                                    :poster="applySenceComponentsPoster" 
                                    :autoplay="true" 
                                    :loop="true" 
                                    class="spi01" 
                                    data-object-fit="true" 
                                    controls 
                                    muted>
                                    <source :src="item" type="video/mp4">
                                    Sorry, your browser does not support embedded videos.
                                </video>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import applySenceComponentsPoster from '@/../public/static/imgs/gameDetailViewPosterMobile03.png';

export default {
    name: 'ApplySencePc',
    data() {
        return {
            tips: 'Hello World',
            applySenceComponentsPoster,
            // Apply Sence 默认选中INDEX
			currentOpenMenuIndex: 0,
            video0Loaded        : true,
            video1Loaded        : false,
            video2Loaded        : false,
            video3Loaded        : false,
            showImgMenuArr: [
                require('@/assets/static/imgs/common/icon_zoom.png'),
                require('@/assets/static/imgs/common/icon_live.png'),
                require('@/assets/static/imgs/common/icon_chat.png'),
                require('@/assets/static/imgs/common/icon_1v1.png')
            ],
            senceVideos: {
                game_center: [
                    require('@/../public/static/apply-sence/game-center-01.mp4'),
                    require('@/../public/static/apply-sence/game-center-02.mp4'),
                    require('@/../public/static/apply-sence/game-center-04.mp4')
                ],
                live_streaming: [
                    require('@/../public/static/apply-sence/1v1-social-01.mp4'),
                    require('@/../public/static/apply-sence/1v1-social-02.mp4'),
                    require('@/../public/static/apply-sence/1v1-social-03.mp4')
                ],
                chat_room: [
                    require('@/../public/static/apply-sence/chat-room-01.mp4'),
                    require('@/../public/static/apply-sence/chat-room-02.mp4'),
                    require('@/../public/static/apply-sence/chat-room-03.mp4')
                ],
                battle_social: [
                    require('@/../public/static/apply-sence/1v1-social-01.mp4'),
                    require('@/../public/static/apply-sence/1v1-social-02.mp4'),
                    require('@/../public/static/apply-sence/1v1-social-03.mp4')
                ]
            }
        }
    },

    methods: {
        // 中部导航菜单（Apply Sence）：子菜单鼠标移入事件
		showBottomContent(index)
		{
			// console.log('=== App__showBottomContent__index >>>', index);
			this.currentOpenMenuIndex = index;
            switch(index) {
                case 0:
                    this.video0Loaded = true;
                    break;
                case 1:
                    this.video1Loaded = true;
                    break;
                case 2:
                    this.video2Loaded = true;
                    break;
                case 3:
                    this.video3Loaded = true;
                    break;
                default:
                    break;
            }

            // Reload the video element to apply the new source
            let elements = document.getElementsByClassName('spi01');
            // console.log(elements);
            this.$nextTick(() => {
                for(let i = 0; i < elements.length; i++) {
                    elements[i].load();
                    // elements[i].style.borderColor = 'red';
                }
            });
		},

        handleError(event)
        {
            return;
            /* console.log('event >>>', event);
            event.target.src = require('@/assets/static/imgs/common/google-cloud.png'); */
        }
    }
}
</script>

<style lang="less" scoped>
.apply_sence_container{
	display:flex;justify-content:center;align-items:flex-start;
	width:100%;height:var(--com-base-top-container-h3);
	.apply_sence_gradient_1{
		width:inherit;height:inherit;
		background:linear-gradient(135deg, rgba(210, 223, 244, 1), rgba(236, 243, 255, 1), rgba(225, 240, 255, 1), rgba(243, 240, 255, 1));
		.apply_sence_gradient_2{
			width:inherit;height:inherit;
            background-position:left bottom;
            background-repeat:no-repeat;
			background-size:374px 400px;
			.apply_sence_main{
				margin:0 auto;padding-top:75px;
				width:var(--com-base-container-w);height:inherit;
				/* background:#CCC; */
				.apply_sence_title{
					height:50px;line-height:50px;
					font-size:var(--com-base-fz-48);font-weight:bold;color:var(--com-main-ft-color);text-align:center;
				}
				.apply_sence_desc{
					height:50px;line-height:50px;
					font-size:var(--com-base-fz-22);font-weight:normal;color:#676D77;text-align:center;
				}
				.apply_sence_menu{
					margin-top:30px;
					display:flex;justify-content:center;align-items:center;
					gap:25px;
					.apply_sence_menu_item{
						width:260px;height:80px;
						border-radius:18px;border:2px solid #FFF;background:#F5F9FF;
						display:flex;justify-content:center;align-items:center;
						font-size:var(--com-base-fz-22);color:#1D55FF;font-weight:bold;
						cursor:pointer;
						img{width:56px;height:56px;}
						&:hover{
							border-color:#1D55FF;background:#FFF !important;
						}
					}
					.active{
						border-color:#1D55FF;background:#FFF !important;
					}
				}
				.apply_sence_content{
					margin-top:90px;
					width:var(--com-base-container-w);height:460px;
					border:2px solid rgba(255, 255, 255, .4);border-radius:18px;
					background:rgba(255, 255, 255, .3);
					display:flex;justify-content:flex-start;align-items:flex-start;
					.apply_sence_content_left{
						width:560px;height:460px;
						padding:40px;
						border-radius:18px 0 0 18px;
                        display:flex;flex-direction:column;justify-content:center;align-items:flex-start;
						p:nth-child(1){
							font-size:var(--com-base-fz-38);color:#5B77A1;font-weight:bold;
						}
						p:nth-child(2){
							padding-top:20px;
							font-size:var(--com-base-fz-22);color:#8798B1;
							line-height:1.6;
						}
					}
					.apply_sence_content_right{
						position:relative;
						width:880px;height:460px;
						.sence_add_box{
							position:absolute;top:-35px;right:35px;
							display:flex;justify-content:center;align-items:center;
							gap:35px;
                            video{
                                width:256px;height:522px;
                                border:5px solid #FFF;border-radius:20px;
                                object-fit:cover;
                                box-shadow:0 4px 20px 0 rgba(0, 0, 0, .3);
                            }
						}
					}
				}
			}
		}
	}
}
</style>